import React, { memo, ChangeEvent, useEffect, useRef } from 'react';

interface IProps {
    value: string;
    maxLength?: number;
    autoFocus?: boolean;
    placeholder?: string;
    onFocus?: VoidFunction;
    onBlur?: VoidFunction;
    onKeyDown?(e: React.KeyboardEvent<HTMLTextAreaElement>): void;
    onChange(value: string): void;
    getDom?(dom: HTMLTextAreaElement): void;
}

import './autoHeightTexarea.scss';

export const AutoHeightTexarea = memo((props: IProps) => {
    const { maxLength, value = '', placeholder = '', autoFocus = false, getDom, onBlur, onFocus, onKeyDown } = props;

    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const ruleRef = useRef<HTMLPreElement>(null);

    useEffect(() => {
        const padding = window.getComputedStyle(textareaRef.current!).padding;
        const lineHieght = window.getComputedStyle(textareaRef.current!).lineHeight;
        ruleRef.current!.style.padding = padding;
        ruleRef.current!.style.lineHeight = lineHieght;
        if (autoFocus && value) {
            textareaRef.current!.value = '';
            textareaRef.current!.value = value;
        }
        if (getDom) {
            getDom(textareaRef.current!);
        }
    }, []);

    const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        props.onChange(e.target.value);
    };

    const render = () => {
        return (
            <div className="auto-height-textarea-wrap">
                <pre className="rule-area" ref={ruleRef}>
                    {value}
                </pre>
                <textarea
                    ref={textareaRef}
                    autoFocus={autoFocus}
                    className="auto-height-textarea"
                    autoComplete="off"
                    maxLength={maxLength}
                    placeholder={placeholder}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    value={value}
                    onKeyDown={onKeyDown}
                ></textarea>
            </div>
        );
    };

    return render();
});
